import { useState, useEffect } from 'react';
import { X, Cookie, Shield } from 'lucide-react';
import { Button } from './ui/button';

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Delay showing banner for better UX
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie-consent', 'all');
    setIsVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem('cookie-consent', 'essential');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-fade-in-up">
      <div className="container-custom">
        <div className="bg-white rounded-2xl shadow-2xl shadow-black/10 border border-[#e2e8f0] p-6 md:p-8 max-w-4xl mx-auto">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-[#1A52D8]/10 flex items-center justify-center flex-shrink-0 hidden md:flex">
              <Cookie className="w-6 h-6 text-[#1A52D8]" />
            </div>
            
            <div className="flex-1">
              <div className="flex items-start justify-between gap-4 mb-4">
                <div>
                  <h3 className="text-lg font-bold text-[#1e293b] mb-1">
                    Wir respektieren Ihre Privatsphäre
                  </h3>
                  <p className="text-[#64748b] text-sm leading-relaxed">
                    Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung zu bieten. 
                    Google Maps benötigt Cookies für die Kartenanzeige auf unserer Kontaktseite.
                  </p>
                </div>
                <button 
                  onClick={acceptEssential}
                  className="text-[#94a3b8] hover:text-[#64748b] transition-colors md:hidden"
                  aria-label="Schließen"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-3">
                <Button 
                  onClick={acceptAll}
                  className="bg-[#1A52D8] text-white hover:bg-[#1545b8] h-11 px-6 rounded-full font-semibold shadow-lg shadow-[#1A52D8]/20"
                >
                  Alle akzeptieren
                </Button>
                <Button 
                  onClick={acceptEssential}
                  className="bg-[#f8fafb] text-[#64748b] hover:bg-[#e2e8f0] h-11 px-6 rounded-full font-semibold"
                >
                  Nur notwendige
                </Button>
                <a 
                  href="/datenschutz" 
                  className="inline-flex items-center justify-center h-11 px-4 text-sm text-[#64748b] hover:text-[#1A52D8] transition-colors"
                >
                  Mehr erfahren
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
